module.exports = __webpack_public_path__ + "img/proprietor_bg.7f932666.png";